<div [hidden]="!isInIframe" style="text-align: center;">
  <img src="/img/loading.gif" alt="loading" />
</div>

<div class="login_page" style="margin-top:48px" *ngIf="!(authenticate$ | async).loading && !isInIframe">

  <div id="loginbox" class="login_box" *ngIf="!(authenticate$ | async).isUserAuthenticated">

    <div class="top_b">Welcome to the AutoRemind Portal</div>
    <div class="alert alert-danger alert-login" *ngIf="(authenticate$ | async).attempts > 0">
      Authentication failed! Please try again.
    </div>

    <div id="login-inner">
      <form id="login_form" [formGroup]="loginForm" (ngSubmit)="login()" >
        <div class="cnt_b" style="padding-top: 10px; padding-bottom: 10px" >
          <div class="form-group">
            <div class="input-group" >
              <span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span>
              <input type="text" class="form-control input-sm" formControlName="username" tabindex="1"/>
            </div>
          </div>

          <div class="form-group">
            <div class="input-group" >
              <span class="input-group-addon"><i class="glyphicon glyphicon-lock"></i></span>
              <input class="form-control input-sm" type="password" formControlName="password" tabindex="2" />
            </div>
          </div>

          <div class="form-group">
            <label class="checkbox-inline"><input type="checkbox" formControlName="rememberMe" class="form-control" tabindex="3" style="width: fit-content; height: auto;"/> Remember me</label>
          </div>
        </div>

        <div class="btm_b clearfix">
          <button class="btn btn-primary btn-sm pull-right" type="submit" tabindex="4">Sign In</button>
          <span class="linkform"><a href="mailto:support@autoremind.us?Subject=Forgot%20password" tabindex="5">Forgot password?</a></span>
        </div>
      </form>
    </div>
  </div>


</div>
<!-- div class="enrollmentPage">
	<iframe ng-if="showEnrollment" src="{{enrollmentUrl | trustUrl}}"></iframe>
</div-->

